import {
  OriginType,
  RobotAIKeywordItem,
  RobotAIKeywordType,
} from "@/app/types/typeConfig/chatQuestion";
import request from "@/request";

const prefix = "/gw/robot";

export interface RobotAIKeywordListProps {
  languageCode: string;
  type: RobotAIKeywordType;
}

export const requireRobotAIKeywordList = async (
  params: RobotAIKeywordListProps,
) => {
  try {
    const dataForm: RobotAIKeywordItem[] = await request.get(
      `${prefix}/ai/key/list?languageCode=${params.languageCode}&type=${params.type}`,
    );
    return Promise.resolve(dataForm);
  } catch (err) {
    return Promise.reject(err);
  }
};

export interface CollectRobotAIKeyProps {
  keyId: string;
  userId: string;
  origin: OriginType;
}

export const collectRobotAIKey = async (params: CollectRobotAIKeyProps) => {
  try {
    await request.post(`${prefix}/ai/key/collect`, {
      ...params,
    });
  } catch (err) {
    return Promise.reject(err);
  }
};
